import React, { useEffect, useState } from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import { separate } from "../../../Utils/SeprateNumber/SeprateThreeNumber";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";
import { GetWithdrawList } from "../../../Api/PanelAdminServices";
import { Select } from "antd";
import moment from "moment-jalaali";
import NewPayReqTabel from "../../Tables/PayReq/NewPayReqTabelSupplier/NewPayReqTabel";
import { Modal } from "react-bootstrap";
import PaymentInfoForm from "../../Forms/PaymentInfoForm/PaymentInfoForm";
const NewPayRequestContainer = () => {
  /////////get data //////
  const [withdrawListState, setWithdrawListState] = useState([]);
  const [userTypeState, setUserTypeState] = useState("supplier");
  const [PaymentModal, setPaymentModal] = useState(false);
  const [userDetailState, setUserDetailState] = useState(null);
  useEffect(() => {
    WithdrawList();
  }, []);

  const WithdrawList = async () => {
    GetWithdrawList((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setWithdrawListState(res.withdraw);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  const Supplierdata =
    userTypeState === "supplier"
      ? withdrawListState &&
        withdrawListState?.supplier?.map((item) => {
          return {
            key: item.id,
            userId: item.user_id,
            name: item.first_name + " " + item.last_name,
            phone: item.phone,
            iban: item.iban,
            date: moment
              .unix(parseInt(item.date))
              .format("jYYYY/jM/jD----hh:mm:ss a"),
            money: `${separate(item.amount * -1 - item.wage * -1)} تومان`,
            track_id: item.track_id,
          };
        })
      : userTypeState === "deliver"
      ? withdrawListState &&
        withdrawListState?.deliver?.map((item) => {
          return {
            key: item.id,
            userId: item.user_id,
            name: item.first_name + " " + item.last_name,
            phone: item.phone,
            iban: item.iban,
            date: moment
              .unix(parseInt(item.date))
              .format("jYYYY/jM/jD----hh:mm:ss a"),
            money: `${separate(item.amount * -1 - item.wage * -1)} تومان`,
            track_id: item.track_id,
          };
        })
      : withdrawListState &&
        withdrawListState?.user?.map((item) => {
          return {
            key: item.id,
            userId: item.user_id,
            iban: item.iban,
            name: item.first_name + " " + item.last_name,
            phone: item.phone,
            date: moment
              .unix(parseInt(item.date))
              .format("jYYYY/jM/jD----hh:mm:ss a"),
            money: `${separate(item.amount * -1 - item.wage * -1)} تومان`,
            track_id: item.track_id,
          };
        });
  const DetailHandler = (detail) => {
    setUserDetailState(detail);
    setPaymentModal(true);
  };
  const SupplierdataNew = Supplierdata?.filter(
    (item) => item.track_id === null
  ).sort((a, b) => a.key - b.key);
  return (
    <section className="w-100 d-flex align-items-center flex-column">
      <TableFixedPage title={"درخواست پرداخت های جدید"} />
      <Select
        defaultValue={"supplier"}
        className="w-75 my-3"
        style={{ width: 120 }}
        onChange={setUserTypeState}
        value={userTypeState}
        options={[
          { value: "user", label: "مشتری" },
          { value: "deliver", label: "پیک یا راننده" },
          { value: "supplier", label: "تامین کننده" },
        ]}
      />
      <Modal
        className="RTL"
        show={PaymentModal}
        onHide={() => setPaymentModal(false)}
      >
        <Modal.Header>
          <Modal.Title className="fs-6">اطلاعات انتقال پول</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaymentInfoForm
            info={userDetailState}
            updateHandler={WithdrawList}
            closeModal={() => setPaymentModal(false)}
          />
        </Modal.Body>
      </Modal>
      <NewPayReqTabel data={SupplierdataNew} showAddress={DetailHandler} />
    </section>
  );
};

export default NewPayRequestContainer;
